export default __webpack_public_path__ + "static/media/zenodo-dropdown.1b92e078.png";